import { InputRef } from "antd";
import Search from "antd/es/input/Search";
import React, { useEffect, useRef, useState } from 'react';
import { notify, NotifyCode } from "../../../../util/varibles/message";
import styles from './style.module.scss';

interface IProps {
    open: boolean
    loading: boolean

    onClose(change?: boolean): void

    onLoad(code?: string): void
}

const SearchBox: React.FC<IProps> = ({ open, onClose, onLoad }) => {
    const [search, setSearch] = useState('');
    const [change, setChange] = useState(false);
    const inputRef = useRef<InputRef>(null);

    useEffect(() => {
        if (open) {
            inputRef.current!.focus({ cursor: 'start' });
            setChange(false);
        }
    }, [open]);
    const onSearch = () => {
        if (search.length !== 6) {
            notify.error(NotifyCode.E38)()
            return;
        }
        setChange(true);
        onLoad(search.toUpperCase());
    }

    return <div className={styles.search} data-open={open}>
        <Search
            ref={inputRef}
            onKeyDown={(e) => {
                if (e.key === 'Escape') {
                    e.preventDefault();
                    e.stopPropagation();
                    if (search.length === 0) {
                        onClose(change)
                    } else {
                        setSearch('');
                        onLoad();
                    }

                    return false;
                }
            }}
            value={search}
            onChange={({ target }) => setSearch(target.value)}
            placeholder="Search by operation code"
            allowClear
            enterButton="Search"
            onSearch={onSearch}
        />
    </div>;
};

export default SearchBox;
